// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"06fdec08","174":"fae03b40","516":"4997b28f","601":"d5ef2e27","727":"d1714327"}[chunkId] + ".chunk.css";
};